<app-breadcrumbs>
</app-breadcrumbs>
<p-table [value]="parameters$ | async" styleClass="p-datatable-sm p-datatable-striped" *transloco="let t; read: 'ime.common.parameters'">
  <ng-template pTemplate="header">
    <tr>
      <th class="col-6">{{t('Name')}}</th>
      <th>{{t('Value')}}</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-parameter>
    <tr>
      <td>{{parameter.Text}}</td>
      <td>
        <button type="button" class="btn btn-sm btn-outline-primary" (click)="edit(parameter)">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
        </button>
      </td>
    </tr>
  </ng-template>
</p-table>
